import { actionTypes } from '../../constants';
import {
  excludedRoomHasRelationConfirm,
  excludedRoomListHasRelationsConfirm,
  lastRoomExcludedConfirm,
} from '../housesModelConfirmation';

class BaseHandler {
  constructor() {
    this._next = null;
  }

  get next() {
    return this._next;
  }

  setNext(handler) {
    this._next = handler;
    return handler;
  }

  handle(request) {
    return this._next ? this._next.handle(request) : false;
  }
}

class ExcludeHouseHandler extends BaseHandler {
  handle({ roomData, housesModel, dispatch }) {
    const data = Array.isArray(roomData) ? roomData : [roomData];

    const houseId = data[0].houseId;

    const house = housesModel.houses.get(houseId);

    const roomCount = house.roomsCount;
    const excludedRoomsCount = house.excludedRoomIds.size;

    if (excludedRoomsCount + data.length === roomCount) {
      const parentRooms = housesModel.houseCrossParentsToRender(house.id);
      const childRooms = housesModel.houseCrossChildrenToRender(house.id);

      lastRoomExcludedConfirm({
        onOk: () => {
          dispatch({ type: actionTypes.houseDeselected, payload: house.id });
        },
        currentHouseId: house.id,
        parentRooms,
        childRooms,
        roomData,
      });

      return true;
    }

    return super.handle({ roomData, housesModel, dispatch });
  }
}

class ExcludedRoomHasRelationHandler extends BaseHandler {
  handle({ roomData, housesModel, dispatch }) {
    const house = housesModel.houses.get(roomData.houseId);
    const room = house.roomsWithRelation.get(roomData.id);

    if (room) {
      const isParent = room.isParent();
      const relation = isParent ? room.toRender() : room.parent.toRender();

      excludedRoomHasRelationConfirm({
        relation,
        isParent,
        currentHouseId: room.houseId,
        onOk: () => {
          dispatch({ type: actionTypes.roomExcluded, payload: roomData });
        },
      });

      return true;
    }

    return super.handle({ roomData, housesModel, dispatch });
  }
}

class ExcludedRoomListHasRelationHandler extends BaseHandler {
  handle({ roomData, housesModel, dispatch }) {
    const houseId = roomData[0].houseId;

    const house = housesModel.houses.get(houseId);

    const parentRooms = [];
    const childRooms = [];
    const addedIds = new Set();

    const addUnique = (list, relation) => {
      if (relation && !addedIds.has(relation.id)) {
        list.push(relation);
        addedIds.add(relation.id);
      }
    };

    const addParentRoom = (parentRoom) =>
      addUnique(parentRooms, parentRoom?.toRender());
    const addChildRoom = (parentRoom) =>
      addUnique(childRooms, parentRoom?.toRender());

    roomData.forEach((room) => {
      const roomModel = house.roomsWithRelation.get(room.id);
      if (!roomModel) return;

      if (roomModel.isParent()) {
        addParentRoom(roomModel);
        return;
      }

      const parentRoom = roomModel.parent;

      parentRoom.houseId === houseId
        ? addParentRoom(parentRoom)
        : addChildRoom(parentRoom);
    });

    if (parentRooms.length || childRooms.length) {
      excludedRoomListHasRelationsConfirm({
        parentRooms,
        childRooms,
        currentHouseId: houseId,
        onOk: () => {
          dispatch({ type: actionTypes.roomListExcluded, payload: roomData });
        },
      });

      return true;
    }

    return super.handle({ roomData, housesModel, dispatch });
  }
}

export {
  ExcludeHouseHandler,
  ExcludedRoomHasRelationHandler,
  ExcludedRoomListHasRelationHandler,
};
